<template>
    <div>
        <Title :name="title" />

        <div class="tile">
            <div class="tile-title-w-btn d-flex justify-content-between align-items-center">
                <h3 class="title">รายงาน</h3>
                <!-- <button class="btn btn-primary icon-btn" @click="openModal('create')">
                    <i class="bi bi-plus-square me-2"></i> เพิ่มแผนก
                </button> -->
            </div>
            <nav class="navbar bg-body-tertiary my-3">
                <div class="container-fluid">
                    <form class="d-flex" role="">
                        <div class="input-group me-2">
                            <label class="input-group-text" for="userSelect">ผู้รับผิดชอบ</label>
                            <select class="form-select" v-model="selectedUserId" id="userSelect">
                                <option disabled value="">-- เลือกผู้ใช้ --</option>
                                <option v-for="user in filteredUsers" :key="user.id" :value="user.id">
                                    {{ user.name }}
                                </option>
                            </select>
                        </div>
                    </form>

       <!-- Export button -->
<button class="btn btn-success ms-2" @click="exportToExcel">
  <i class="bi bi-file-earmark-excel"></i> ส่งออก Excel
</button>

                    <form class="d-flex ms-auto align-items-center">
                        <div class="input-group">
                            <span class="input-group-text">เดือน</span>
                            <select class="form-select" v-model="month" id="inputGroupSelect01">
                                <option v-for="(monthName, index) in months" :key="index" :value="index + 1">
                                    {{ monthName }}
                                </option>
                            </select>
                            <span class="input-group-text">ปี</span>
                            <select class="form-select" v-model="year" id="inputGroupSelect01">
                                <option v-for="yearOption in years" :key="yearOption" :value="yearOption">
                                    {{ convertToBE(yearOption) }}
                                </option>
                            </select>
                        </div>

                        <div class="input-group" hidden>
                            <label class="input-group-text" for="inputGroupSelect01">ปี</label>
                            <select class="form-select" v-model="year" id="inputGroupSelect01">
                                <option v-for="yearOption in years" :key="yearOption" :value="yearOption">
                                    {{ convertToBE(yearOption) }}
                                </option>
                            </select>
                        </div>
                    </form>
                </div>
            </nav>
            <div class="tile-body">
                <table class="table table-lg table-bordered table-striped table-inverse">
                    <thead class="text-center thead-inverse">
                        <tr>
                            <th>#</th>
                            <th width="150">วันที่ เวลา</th>
                            <th>ประเภท</th>
                            <th>ผู้ใช้บริการ</th>
                            <th>หน่วยงาน</th>
                            <th>รายละเอียด</th>
                            <th>สถานที่</th>
                            <th>ติดต่อ</th>
                            <th>สถานะ</th>
                            <th>ผู้รับผิดชอบ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in data" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>
                                <p class="m-0">วันที่: {{ formatDate(item.date) }}</p>
                                <p class="m-0">เวลา: {{ formatTime(item.time) }}</p>
                            </td>
                            <td>{{ item.service_type?.name }}</td>
                            <td>{{ item.end_user }}</td>
                            <td>{{ item.department?.name }}</td>
                            <td>{{ item.details }}</td>
                            <td>{{ item.location || '-' }}</td>
                            <td>{{ item.tel || '-' }}</td>
                            <td>
                                <span class="badge rounded-pill" :class="statusClass(item.status_id)">
                                    {{ item.status?.name }}
                                </span>
                            </td>
                            <td>{{ item.user?.name }}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>


    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import Title from './layouts/Title.vue';
import moment from 'moment';
import { formatDate, formatTime } from '@/utils/dateUtils';
import * as XLSX from 'xlsx';
import { watch } from 'vue';
import API from '@/services/http-common'

moment.locale("th");
const title = 'รายงาน';

// Filter controls
const month = ref(moment().month() + 1);
const months = ref(moment.months());
const year = ref(new Date().getFullYear());
const years = computed(() => {
    const startYear = new Date().getFullYear() - 2;
    return Array.from({ length: 3 }, (v, i) => startYear + i);
});
const convertToBE = (year) => year + 543;

// Data
const data = ref();

// Fetch from API
const fetchData = async () => {
    if (!selectedUserId.value) return;

    try {
        const response = await API.get('items', {
            params: {
                user_id: selectedUserId.value,
                month: month.value,
                year: year.value
            }
        });
        data.value = response.data;
    } catch (error) {
        console.error('Error fetching report data:', error);
    }
};

const selectedUserId = ref(''); // Stores the selected user ID
const filteredUsers = ref([]);  // This will be set after API call

const fetchAdmins = async () => {
    try {
        const res = await API.get('admins');
        const allAdmins = res.data;
        filteredUsers.value = allAdmins
            .filter(admin => admin.access_id === 5)
            .map(admin => admin.user);
    } catch (error) {
        console.error('Failed to fetch admins:', error);
    }
};

const exportToExcel = () => {
    if (!data.value || data.value.length === 0) return;

    const worksheetData = data.value.map((item, index) => ({
        ลำดับ: index + 1,
        'วันที่': formatDate(item.date),
        'เวลา': formatTime(item.time),
        'ประเภทบริการ': item.service_type?.name || '',
        'ผู้ใช้บริการ': item.end_user || '',
        'หน่วยงาน': item.department?.name || '',
        'รายละเอียด': item.details || '',
        'สถานที่': item.location || '-',
        'ติดต่อ': item.tel || '-',
        'สถานะ': item.status?.name || '',
        'ผู้รับผิดชอบ': item.user?.name || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'รายงาน');

    XLSX.writeFile(workbook, `รายงาน_${formatDate(new Date())}.xlsx`);
};


watch([selectedUserId, month, year], () => {
    fetchData();
});

onMounted(() => {
    fetchData();
    fetchAdmins();
});

// Status badge class helper
const statusClass = (statusId) => {
    switch (statusId) {
        case 1: return 'bg-secondary';
        case 2: return 'bg-warning';
        case 3: return 'bg-success';
        default: return 'bg-dark';
    }
};
</script>


<style scoped></style>